import React, { useState } from 'react';
import { CommandMenu } from './ui/CommandMenu';
import { TeamSwitcherMenu } from './ui/TeamSwitcherMenu';
import { UserMenu } from './ui/UserMenu';
import { NotificationsMenu } from './ui/NotificationsMenu';
import { QuickActions } from './ui/QuickActions';
import { Link } from 'react-router-dom';
import { Settings, Users, Bell, Key, Activity } from 'lucide-react';
import { ScanStatusMenu } from './ui/ScanStatusMenu';

// Sample data
const currentUser = {
  name: 'John Smith',
  email: 'john@example.com',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=32&h=32&fit=crop&crop=face'
};

const teams = [
  { id: '1', name: 'Acme Corp', role: 'Admin' },
  { id: '2', name: 'Startup Inc', role: 'Member' },
  { id: '3', name: 'Tech Labs', role: 'Owner' },
];

const notifications = [
  {
    id: '1',
    type: 'security',
    title: 'Critical Vulnerability Detected',
    description: 'SQL injection vulnerability found in the login endpoint',
    timestamp: '2 minutes ago',
    read: false
  },
  {
    id: '2',
    type: 'credential',
    title: 'New Credential Leak',
    description: 'API key exposed in public GitHub repository',
    timestamp: '10 minutes ago',
    read: false
  },
  {
    id: '3',
    type: 'data',
    title: 'Sensitive Data Exposure',
    description: 'Customer data found in public S3 bucket',
    timestamp: '1 hour ago',
    read: true
  }
];

const Header = () => {
  const handleOrgChange = (orgId: string) => {
    console.log('Switching to org:', orgId);
  };

  const handleSignOut = () => {
    console.log('Signing out...');
  };

  const handleNotificationRead = (id: string) => {
    console.log('Marking notification as read:', id);
  };

  const handleViewAllNotifications = () => {
    console.log('Viewing all notifications');
  };

  const handleQuickAction = (actionId: string) => {
    console.log('Executing quick action:', actionId);
  };

  return (
    <header className="h-16 px-4 border-b border-gray-800 flex items-center justify-between bg-[#0F1629] gap-4">
      <CommandMenu className="flex-1" />
      
      <div className="flex items-center space-x-4">
        <div className="relative group">
          <button
            className="p-2 text-gray-400 hover:text-white hover:bg-gray-800/50 rounded-lg transition-colors group-hover:bg-gray-800/50"
          >
            <Activity className="h-5 w-5" />
          </button>
          <ScanStatusMenu />
        </div>

        <TeamSwitcherMenu />

        <QuickActions onAction={handleQuickAction} />

        <NotificationsMenu
          // notifications={notifications}
          // onMarkAsRead={handleNotificationRead}
          // onViewAll={handleViewAllNotifications}
        />
        
        <UserMenu />
      </div>
    </header>
  );
};

export default Header;